
import AdminPageDataTable from '../../../components/AdminPageDataTable.vue'
export default {
    components: {
        AdminPageDataTable
    },
    mounted() {
       
    },
    data: () => ({
        apiLink: "api/web/new-event/get-admin-news-and-events",
        apiSaveLink: "api/web/new-event/save",
        apiDeleteLink: "api/web/new-event/delete",
        slots: [{ title: 'item.title', header: 'title', type: 'text',col:'title' },
         { title: 'item.date', header: 'date', type: 'date',col:'date' },
        {title: 'item.author', header: 'author', type: 'text' ,col:'author'},
        {title: 'item.address', header: 'address', type: 'textarea',col:'address' },
        {title: 'item.content', header: 'content', type: 'textarea',col:'content' }],
        switchSlots: [],
        headers: [

            { text: 'Id', value: 'id' },
            { text: 'Title', value: 'title' },
            { text: 'Published on', value: 'date' },
            { text: 'Author', value: 'author' },
            { text: 'Address', value: 'address' },   { text: 'Content', value: 'content' },
            { text: 'Actions', value: 'actions' },
        ]
    }),

};